module.exports = __webpack_public_path__ + "img/zixishi_prod.6f97a6eb.png";